import { topSidePartOfWeb } from './parts/sideParts'

export const bomberOriginalReverseWeb = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  // ウェブ本体
  ctx.beginPath()
  ctx.moveTo(300, 376) // 左下
  ctx.quadraticCurveTo(339, 334, 373, 252) // 右下
  ctx.quadraticCurveTo(384, 159, 359, 92) // 右上
  ctx.quadraticCurveTo(269, 153, 210, 260) // 左上
  ctx.quadraticCurveTo(300, 376, 300, 376) // 左下
  ctx.fill()
  // 斜線上段
  ctx.moveTo(365, 200) // 右上
  ctx.quadraticCurveTo(290, 214, 235, 266) // 左下
  // 斜線下段
  ctx.moveTo(373, 245) // 右上
  ctx.quadraticCurveTo(305, 267, 261, 315) // 左下
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 斜線上周り＿外
  ctx.moveTo(232, 264) // 左上
  ctx.quadraticCurveTo(261, 175, 352, 110) // 右上
  ctx.quadraticCurveTo(362, 196, 362, 198) // 左下
  ctx.quadraticCurveTo(305, 203, 232, 264) // 右下
  // 斜線上周り＿内
  ctx.moveTo(235, 263) // 左上
  ctx.quadraticCurveTo(261, 182, 348, 115) // 右上
  ctx.quadraticCurveTo(358, 196, 358, 195) // 左下
  ctx.quadraticCurveTo(305, 200, 232, 261) // 右下
  // 斜線中周り_外
  ctx.moveTo(262, 308) // 左上
  ctx.quadraticCurveTo(301, 266, 368, 243) // 右下
  ctx.quadraticCurveTo(362, 205, 362, 205) // 右上
  ctx.quadraticCurveTo(295, 220, 238, 268) // 左下
  // 斜線中周り_内
  ctx.moveTo(262, 302) // 左上
  ctx.quadraticCurveTo(301, 263, 365, 240) // 右下
  ctx.quadraticCurveTo(358, 210, 358, 210) // 右上
  ctx.quadraticCurveTo(295, 225, 238, 273) // 左下
  // 斜線下周り_外
  ctx.moveTo(269, 310) // 左上
  ctx.quadraticCurveTo(314, 270, 368, 250) // 右上
  // 斜線下周り_内
  ctx.moveTo(269, 314) // 左上
  ctx.quadraticCurveTo(314, 274, 368, 254) // 右上

  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで

  // laceここから
  // 上段
  crossLaceOfBomberWeb(ctx, laceColor, -30, 0)
  crossLaceOfBomberWeb(ctx, laceColor, 0, -20)
  crossLaceOfBomberWeb(ctx, laceColor, 35, -40)
  crossLaceOfBomberWeb(ctx, laceColor, 70, -55)
  // 右側
  ctx.beginPath()
  ctx.moveTo(352, 193) // 左上
  ctx.quadraticCurveTo(360, 213, 360, 218) // 左下
  ctx.quadraticCurveTo(366, 214, 366, 208) // 右下
  ctx.quadraticCurveTo(365, 188, 358, 185) // 右上
  ctx.quadraticCurveTo(352, 185, 352, 193) // 左上
  ctx.fill()
  // // 断面ライン
  ctx.moveTo(352, 191) // 左上
  ctx.quadraticCurveTo(364, 203, 362, 218) // 左下
  ctx.stroke()
  ctx.closePath()

  // 下段
  crossLaceOfBomberWeb(ctx, laceColor, 10, 30)
  crossLaceOfBomberWeb(ctx, laceColor, 45, 10)
  crossLaceOfBomberWeb(ctx, laceColor, 80, -10)
  // ウェブ先端
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
}

const crossLaceOfBomberWeb = (ctx: CanvasRenderingContext2D, color: string, x: number, y: number): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = color
  // 左側
  ctx.beginPath()
  ctx.moveTo(259 + x, 265 + y) // 左上
  ctx.quadraticCurveTo(270 + x, 274 + y, 281 + x, 273 + y) // 左下
  ctx.quadraticCurveTo(285 + x, 267 + y, 282 + x, 266 + y) // 右下
  ctx.quadraticCurveTo(261 + x, 255 + y, 261 + x, 255 + y) // 右上
  ctx.quadraticCurveTo(256 + x, 258 + y, 259 + x, 265 + y) // 左上
  ctx.fill()
  // 断面ライン
  ctx.moveTo(261 + x, 255 + y) // 左上
  ctx.quadraticCurveTo(263 + x, 262 + y, 282 + x, 266 + y) // 右下
  ctx.stroke()
  ctx.closePath()

  // 右側
  ctx.beginPath()
  ctx.moveTo(266 + x, 247 + y) // 左上
  ctx.quadraticCurveTo(271 + x, 263 + y, 270 + x, 285 + y) // 左下
  ctx.quadraticCurveTo(273 + x, 285 + y, 276 + x, 278 + y) // 右下
  ctx.quadraticCurveTo(277 + x, 250 + y, 271 + x, 237 + y) // 右上
  ctx.quadraticCurveTo(266 + x, 238 + y, 266 + x, 247 + y) // 左上
  ctx.fill()
  // 断面ライン
  ctx.moveTo(266 + x, 247 + y) // 下
  ctx.quadraticCurveTo(274 + x, 263 + y, 270 + x, 285 + y) // 左下
  ctx.stroke()
  ctx.closePath()
}
